import { useMutation } from '@apollo/client'
import { Col, Form as AntForm, Row } from 'antd'
import { motion } from 'framer-motion'
import React from 'react'
import { AiFillPhone } from 'react-icons/ai'
import { GiPadlockOpen } from 'react-icons/gi'
import { IoFlagSharp, IoPersonCircleSharp } from 'react-icons/io5'
import { MdEmail, MdLock } from 'react-icons/md'
// import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom'
import countryList from 'react-select-country-list'
import {
  authComponentTransition,
  authPageTransition,
} from '../../animation/index'
import { SEND_OTP, SIGN_UP } from '../../app/apollo/index'
import { AuthenticationLayout } from '../../globalComponents/AuthenticationLayout'
import { DropDown } from '../../globalComponents/DropDown'
import { Label } from '../../globalComponents/globalStyle'
import { LoggerButton, PasswordInput } from '../../globalComponents/Index'
import { ModalComponent } from '../../globalComponents/Modal'
import { TextInput } from '../../globalComponents/TextInput'
import withAuthentication from '../../HOC/withoutAuth'
import { NotificationAlert } from '../../utils/NotificationAlert'
import {
  Account,
  InputDiv,
  NotificationText,
  StyledInput,
  Text1,
  Text2,
} from './style'
interface countryInterface {
  countryCode?: string
  name?: string
}
interface UserValueInterface {
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  phone?: string
  homeCountry?: string
  // $currentCountry: string;
  // $otp: string;
}
const Register: React.FC = () => {
  const [sendOtp] = useMutation(SEND_OTP)
  const [signUp] = useMutation(SIGN_UP)
  const [loading, setLoading] = React.useState(false)
  const [otpLoading, setOtpLoading] = React.useState(false)
  const [submitLoading, setSubmitLoading] = React.useState(false)
  const [location, setLocation] = React.useState(false)
  const [coord, setCoords] = React.useState<any>({})
  const [openModal, setOpenModal] = React.useState(false)
  const [country, setCountry] = React.useState<countryInterface>({})
  const [usersValue, setUsersValue] = React.useState<any>({})
  const history = useHistory()

  const onSubmit = async (values: any) => {
    console.log(values)
    setSubmitLoading(true)

    console.log('userValues is', usersValue)
    async function onGeolocateSuccess(coordinates: any) {
      const { latitude, longitude } = coordinates.coords
      console.log('Found coordinates: ', latitude, longitude)
      setLocation(true)
      // setCoords({ lat: `${latitude}`, lng: `${longitude}` });
      try {
        const response: any = await signUp({
          variables: {
            firstname: `${usersValue.firstname}`.toLowerCase().trim(),
            lastname: `${usersValue.lastname}`.toLowerCase().trim(),
            email: `${usersValue.email}`.toLowerCase().trim(),
            password: `${usersValue.password}`.toLowerCase().trim(),
            phone: `${usersValue.phone}`.trim(),
            homeCountry: `${usersValue.homeCountry}`,
            otp: `${values.Otp}`,
            currentCountry: { lat: `${latitude}`, lng: `${longitude}` },
          },
        })
        console.log('a response', response)
        if (response) {
          setSubmitLoading(false)
          console.log(response)
          setSubmitLoading(false)

          if (response?.data?.signUp.success) {
            localStorage.setItem('token', response?.data?.signUp?.access_token)
            history.replace('/onboard')
            setOpenModal(false)
          } else {
            NotificationAlert('error', 'Error', response?.data?.signUp.msg)
          }
        }
      } catch (e) {
        console.log(e.message)
        console.log(e)
        NotificationAlert('error', 'Error', 'Unable to SignUp')
        // console.log(response);
        setSubmitLoading(false)
      }
    }
    function onGeolocateError(error: any) {
      console.warn(error.code, error.message)
      setLocation(false)
      setSubmitLoading(false)
      if (error.code === 1) {
        alert(
          'Kindly allow access to location and to have acccess to exclusive features',
        )
      } else if (error.code === 2) {
        alert(
          'Location is currently unavailable, you have access to some featuers',
        )
      } else if (error.code === 3) {
        alert('Timeout')
      }
    }
    if (window.navigator && window.navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        onGeolocateSuccess,
        onGeolocateError,
      )
    }
  }

  const resendOtp = async (value: any) => {
    setOtpLoading(true)
    try {
      const { data } = await sendOtp({
        variables: {
          email: `${value}`.toLowerCase().trim(),
        },
      })
      if (data) {
        setOtpLoading(false)
        // console.log("there is an error 1", response?.data?.sentOtp?.msg);

        if (data?.sendOtp?.success === true) {
          NotificationAlert('success', 'Success', data?.sendOtp?.msg)
        } else {
          NotificationAlert('error', 'Error', data?.sendOtp?.msg)
        }
      }
      console.log('the response', data)
    } catch (e) {
      setOtpLoading(false)
      console.log('the error', e)
    }
  }

  const onFinish = async (values: any) => {
    console.log(values)
    setUsersValue({ ...values })
    setLoading(true)
    try {
      const { data } = await sendOtp({
        variables: {
          email: `${values.email}`,
        },
      })
      console.log('then data is', typeof data)
      if (data) {
        setLoading(false)

        if (data?.sendOtp?.success === true) {
          setOpenModal(true)
        } else {
          NotificationAlert('error', 'Error', data?.sendOtp?.msg)
        }
      }
      // console.log("the response", data);
    } catch (e) {
      setLoading(false)
      console.log('the error', e)
    }

    //   history.replace("/onboard")
  }
  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo)
  }
  const [value, setValue] = React.useState('')
  const options = React.useMemo(() => countryList().getData(), [])

  const changeHandler = (value: any) => {
    setValue(value)
  }
  return (
    <AuthenticationLayout>
      <motion.div
        variants={authPageTransition}
        transition={authComponentTransition}
        exit="out"
        animate="in"
        initial="initial"
      >
        <ModalComponent visible={openModal} onCancel={() => {}}>
          <div style={{ padding: '1vw', width: '100%' }}>
            <NotificationText>
              An OTP (One Time Password) has been sent to{' '}
              <span>{usersValue.email}</span>, kindly copy and paste below{' '}
            </NotificationText>
            <br />
            <AntForm
              layout="vertical"
              onFinish={onSubmit}
              onFinishFailed={onFinishFailed}
            >
              <AntForm.Item
                name="Otp"
                label={
                  <Label>
                    <div className="active">
                      <GiPadlockOpen />
                    </div>{' '}
                    <h3>OTP</h3>
                  </Label>
                }
              >
                <div>
                  <TextInput
                    required={true}
                    type="text"
                    placeholder="Enter Otp"
                  />
                </div>
              </AntForm.Item>
              <Row justify="space-between" style={{ marginTop: '1vw' }}>
                <Col md={{ span: 10 }}>
                  <LoggerButton
                    // colorProp={true}
                    loading={otpLoading}
                    onClick={() => resendOtp(usersValue.email)}
                    text="Resend OTP"
                  />
                </Col>
                <Col md={{ span: 10 }}>
                  <LoggerButton
                    loading={submitLoading}
                    htmlType="submit"
                    text="Submit"
                  />
                </Col>
              </Row>{' '}
            </AntForm>
          </div>
        </ModalComponent>
        <h3>SIGN UP</h3>
        <AntForm
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row>
            <Col xs={{ span: 24 }} md={{ span: 11 }}>
              <AntForm.Item
                name="firstname"
                rules={[
                  {
                    required: true,
                    message: 'field is required',
                  },
                ]}
                label={
                  <Label>
                    <div className="active">
                      <IoPersonCircleSharp />
                    </div>{' '}
                    <h3>First Name</h3>
                  </Label>
                }
              >
                {/* <InputDiv>
                  <StyledInputBorderless bordered={false} type="text" />
                </InputDiv> */}
                <div>
                  {' '}
                  <TextInput
                    required={true}
                    type="text"
                    placeholder="Enter first name"
                    name="firstname"
                  />{' '}
                </div>
              </AntForm.Item>{' '}
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
              <AntForm.Item
                name="lastname"
                rules={[
                  {
                    required: true,
                    message: 'field is required',
                  },
                ]}
                label={
                  <Label>
                    <div className="active">
                      <IoPersonCircleSharp />
                    </div>{' '}
                    <h3>Last Name</h3>
                  </Label>
                }
              >
                <div>
                  {' '}
                  <TextInput
                    required={true}
                    type="text"
                    placeholder="Enter last name"
                    name="lastname"
                  />
                </div>
              </AntForm.Item>{' '}
            </Col>
          </Row>
          <AntForm.Item
            name="email"
            rules={[
              {
                required: true,
                message: 'field is required',
              },
            ]}
            label={
              <Label>
                <div className="active">
                  <MdEmail />
                </div>{' '}
                <h3>Email Address</h3>
              </Label>
            }
          >
            <div>
              <TextInput
                required={true}
                type="email"
                placeholder="Enter email"
              />
            </div>
          </AntForm.Item>

          <AntForm.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'field is required',
              },
              { min: 8, message: 'must contain at least 8 characters' },
            ]}
            label={
              <Label>
                <div>
                  <MdLock />
                </div>{' '}
                <h3>Password</h3>
              </Label>
            }
          >
            <div>
              <PasswordInput
                required={true}
                type="text"
                placeholder="Enter password"
                name="password"
              />
            </div>
          </AntForm.Item>
          <AntForm.Item
            name="phone"
            rules={[
              {
                required: true,
                message: 'field is required',
              },
            ]}
            label={
              <Label>
                <div className="active">
                  <AiFillPhone />
                </div>{' '}
                <h3>Phone Number</h3>
              </Label>
            }
          >
            {/* <TextInput
              required={true}
              type="number"
              placeholder="Enter phone number"
              name="phoneNumber"
            /> */}
            <InputDiv>
              <StyledInput
                inputClass="inputStyle"
                containerClass="containerStyle"
                dropdownClass="dropdownStyle"
                buttonClass="buttonStyle"
                searchClass="searchStyle"
                country={'us'}
                onChange={(e, c) => setCountry(c)}
              />
            </InputDiv>
          </AntForm.Item>

          <AntForm.Item
            name="homeCountry"
            rules={[
              {
                required: true,
                message: 'field is required',
              },
            ]}
            label={
              <Label>
                <div className="active">
                  <IoFlagSharp />
                </div>{' '}
                <h3>Home Country</h3>
              </Label>
            }
          >
            <div>
              {/* <TextInput
                value={country && country?.name}
                // onChange={(e, c) => console.log(c)}
              /> */}

              <DropDown
                required={true}
                placeholder="Select a Country"
                values={options}
                onChange={changeHandler}
              />
            </div>
          </AntForm.Item>
          <div
            style={{
              margin: '0px 0 10px 0',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Text2>
              <input type="checkbox" required />
            </Text2>
            <Text1 style={{ marginTop: '0px' }}>
              By registering I agree to Atlaskit Software's{' '}
              <span>Terms of Service and Privacy Policy</span>
            </Text1>
          </div>
          <LoggerButton
            loading={loading}
            width="80%"
            htmlType="submit"
            text="Sign Up"
          />
        </AntForm>
        <Account>
          Already have an account?{' '}
          <span onClick={() => history.push('/login')}>Login here</span>
        </Account>
      </motion.div>
    </AuthenticationLayout>
  )
}

export default withAuthentication(Register)
